module.exports = __webpack_public_path__ + "img/Canoe-Slalom.5fc23c75.png";